//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';

export default {
  openCartPreview() {
    Dispatcher.dispatchAction(Constants.OPEN_CART_PREVIEW);
  },

  closeCartPreview() {
    Dispatcher.dispatchAction(Constants.CLOSE_CART_PREVIEW);
  },
};
